$(document).ready(function() {
    // Function to check if an element is in the viewport
    function isInViewport(element) {
        let elementTop = element.offset().top;
        // var elementBottom = elementTop + element.height();
        let viewportTop = $(window).scrollTop() + $('.js-page-header').height();
        // var viewportBottom = viewportTop + $(window).height();

        return elementTop > viewportTop + $(window).height() / 3;
        // return elementBottom + 300 > viewportBottom;
    }

    // Add class 'visible' to elements in the viewport
    $(window).scroll(function() {
        let windowWidth = $(window).width();

        if (windowWidth > 812) {
            $('.js-scrolling-item').each(function(index, element) {
                if (isInViewport($(element))) {
                    $(element).find('.js-optional-content').slideUp(500);
                    $(element).addClass('not-active');
                } else {
                    $(element).removeClass('not-active');
                    $(element).find('.js-optional-content').slideDown(500);
                }
            });
        }
    });

    $(window).on("load resize",function(e){
        let windowWidth = $(window).width();
        if (windowWidth <= 812) {
            $('.js-scrolling-item').addClass('not-active');
            $('.js-scrolling-item').find('.js-optional-content').slideUp(500);
        }
    });

    $('.js-scrolling-block-btn').click(function() {
        let key = $(this).data('key');
        //$('.js-scrolling-block-btn').removeClass('active');
        $('.js-scrolling-block-btn').not(this).removeClass('active');
        $(this).toggleClass('active');
        $('.js-scrolling-item').each(function(index, element) {
            if(index === key) {
                dl.log('yes');
                $(element).toggleClass('not-active');
                $(element).find('.js-optional-content').slideToggle(500);
            } else {
                dl.log('no');
                $(element).addClass('not-active');
                $(element).find('.js-optional-content').slideUp(500);
            }
        });
    });
});
